<header class="modal__header">
  <h2>{{ content.text?.title }}</h2>
  <a class="button button--transparent modal__button--close" (click)="closeModal(true)">
    <i class="icon icon-ui-close--sm"></i>
  </a>
</header>
<div class="modal__content">
  <div class="modal__text" [internalInnerHtml]="content.text?.body" [userEventSource]="userEventSource"></div>
</div>
<div [ngClass]="content.hideCancelButton ? 'modal__footer' : 'modal__footer--full-width-ends'">
  <a *ngIf="content.hideCancelButton !== true" class="button button--secondary" (click)="cancel($event)">
    <span>{{ content.cancelText }}</span>
  </a>
  <a
    (click)="confirmAction($event)"
    class="button"
    [ngClass]="content.hideCancelButton ? 'button--primary' : 'button--cta'"
    [airButtonLoading]="isLoading"
  >
    <span>{{ content.confirmText }}</span>
  </a>
</div>
